import { useQueryClient as reactQueryUseQueryClient } from '@tanstack/react-query';

const useQueryClient = params => reactQueryUseQueryClient(params);

export default useQueryClient;
